// extracted by mini-css-extract-plugin
module.exports = {"modalHeader":"styles-module--modalHeader--2u1dw","modalCloseButton":"styles-module--modalCloseButton--Epl0S"};